import React, { useState } from "react";
import {
  Box,
  TextField,
  FormControl,
  InputLabel,
  Divider,
  Select,
  Button,
  Grid,
  Typography,
  Card,
  CardContent,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import provincias from "../../../constants/provincias";
import { consultaMedicos } from "../../../services/MedicalStaffService";
import { Estados, estadosArr } from "../../../constants/estados";

export const MedicalStaffSearch = ({ onSearch }) => {
  const [searchCriteria, setSearchCriteria] = useState({
    nombre: "",
    apellido: "",
    dni: "",
    especialidad: "",
    tipoMatricula: "",
    nroMatricula: "",
    provinciaMatricula: "",
    // aprobado: false,
    page: 1,
  });

  const handleInputChange = (e) => {
    if (e.target.value === "none") {
      const { estado, ...criteriaWithOutEstado } = searchCriteria;
      setSearchCriteria(criteriaWithOutEstado);
    } else {
      setSearchCriteria({
        ...searchCriteria,
        [e.target.name]: e.target.value,
      });
    }
  };

  const handleSearch = async () => {
    try {
      const result = await consultaMedicos(searchCriteria);
      if (result.error) {
        console.error("Error al realizar la búsqueda:", result.error);
      } else {
        onSearch(result);
      }
    } catch (error) {
      console.error("Error general al realizar la búsqueda:", error);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    handleSearch();
  };

  return (
    <Accordion
      defaultExpanded={false}
      sx={{
        border: "0.5px solid #dddddd",
        padding: "1px",
        boxShadow: "1px 1px #d5d5d5",
        borderRadius: "8px",
        marginBottom: "20px",
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography sx={{ fontWeight: "500" }}>Filtrar búsqueda</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Card
          sx={{
            border: "0.5px solid #dddddd",
            padding: "1px",
            boxShadow: "1px 1px #d5d5d5",
            width: "100%",
          }}
        >
          <CardContent>
            <form onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <Grid item md={4} xs={12}>
                  <TextField
                    label="Nombre"
                    name="nombre"
                    onChange={handleInputChange}
                    value={searchCriteria.nombre}
                    variant="outlined"
                    fullWidth
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <TextField
                    label="Apellido"
                    name="apellido"
                    onChange={handleInputChange}
                    value={searchCriteria.apellido}
                    variant="outlined"
                    fullWidth
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <TextField
                    label="Número de DNI"
                    name="dni"
                    onChange={handleInputChange}
                    value={searchCriteria.dni}
                    variant="outlined"
                    fullWidth
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <FormControl
                    fullWidth
                    variant="outlined"
                    // sx={{ my: 1, marginBottom: 2 }}
                  >
                    <InputLabel
                      htmlFor="registrationType"
                      sx={{ color: "text.primary" }}
                    >
                      Tipo de Matrícula
                    </InputLabel>
                    <Select
                      native
                      onChange={handleInputChange}
                      value={searchCriteria.tipoMatricula}
                      label="Tipo de Matrícula"
                      inputProps={{
                        name: "tipoMatricula",
                        id: "tipoMatricula",
                      }}
                      sx={{ color: "text.primary" }}
                    >
                      <option value=""></option>
                      <option value="MN">Matrícula Nacional</option>
                      <option value="MP">Matrícula Provincial</option>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item md={4} xs={12}>
                  <TextField
                    label="Número de matrícula"
                    name="nroMatricula"
                    onChange={handleInputChange}
                    value={searchCriteria.nroMatricula}
                    variant="outlined"
                    fullWidth
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <FormControl
                    fullWidth
                    variant="outlined"
                    // sx={{ my: 1, marginBottom: 2 }}
                  >
                    <InputLabel
                      htmlFor="provincia"
                      sx={{ color: "text.primary" }}
                    >
                      Provincia
                    </InputLabel>
                    <Select
                      native
                      onChange={handleInputChange}
                      value={searchCriteria.provinciaMatricula}
                      label="Provincia"
                      inputProps={{
                        name: "provinciaMatricula",
                        id: "provinciaMatricula",
                      }}
                      sx={{ color: "text.primary" }}
                    >
                      <option value=""></option>
                      {provincias.map((prov) => (
                        <option key={prov.recipe} value={prov.recipe}>
                          {prov.sisa}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item md={4} xs={12}>
                  <FormControl
                    fullWidth
                    variant="outlined"
                    sx={{ my: 1, marginBottom: 2 }}
                  >
                    <InputLabel htmlFor="estado" sx={{ color: "text.primary" }}>
                      Estado
                    </InputLabel>
                    <Select
                      native
                      onChange={handleInputChange}
                      value={searchCriteria.estado}
                      label="Estado"
                      inputProps={{
                        name: "estado",
                        id: "estado",
                      }}
                      defaultValue="none"
                      sx={{ color: "text.primary" }}
                    >
                      <option value="none">Seleccionar estado</option>
                      {estadosArr.map((estado) => (
                        <option value={estado.value} key={estado.estado}>
                          {estado.estado}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <Divider />
              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                <Button type="submit" variant="contained" color="primary">
                  Consultar
                </Button>
              </Box>
            </form>
          </CardContent>
        </Card>
      </AccordionDetails>
    </Accordion>
  );
};
